<script lang="ts" setup>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import { useClaimStore, useContextStore, useNotificationStore } from '@/store';
import TopMenu from '@/components/TopMenu.vue';
import ClaimSteps from '@/components/overview/ClaimSteps.vue';
import FallbackClaimNotFound from '@/components/claim/FallbackClaimNotFound.vue';
import { TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XMarkIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

const open = ref(false)
const route = useRoute();

watch(() => route.params.id, async newId => {
  useNotificationStore().clear();

  if (typeof newId === 'string') {
    useClaimStore().retrieveClaim(newId)
    open.value = true
  }
}, { immediate: true })

watch(() => open.value, newValue => {
  if (newValue === false) {
    // router.push({
    //   params: { id: null }
    // });
  }
});

function closePlugin() {
  open.value = false;
  // Commenting the line below because it breaks the animation
  // router.push({ name: "Claims" });
  useNotificationStore().clear();
}
</script>
<template>
<TransitionRoot as="template" :show="open">
  <RouterView v-slot="{ Component }">
    <template v-if="Component">
          <div>
            <div class="absolute inset-0 overflow-hidden">
              <div :class="useContextStore().isPlatformBrowser ? 'fixed inset-y-0 right-0 flex max-w-full pl-10 pointer-events-none' : ''">
                <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0" leave-to="translate-x-full">
                  <div class="relative w-screen h-screen pointer-events-auto 2xl:max-w-1/3" :style="{ 'max-width': 34.5 + 'rem' }">
                    <TransitionChild as="template" enter="ease-in-out duration-500" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-500" leave-from="opacity-100" leave-to="opacity-0">
                      <div class="absolute top-0 flex pt-4 pr-2 -ml-6 -left-4 sm:-ml-8 sm:pr-4">
                        <button @click="closePlugin" id="close-plugin" type="button" class="text-gray-400 bg-white border border-gray-300 rounded-full shadow-md hover:text-gray-500 focus:outline-none focus:ring-3 focus:ring-white" >
                          <span class="sr-only">Close panel</span>
                          <div class="p-2">
                            <XMarkIcon class="w-6 h-6" aria-hidden="true" />
                          </div>
                          <!-- <ChevronRightIcon class="w-8 h-8" aria-hidden="true" /> -->
                        </button>
                      </div>
                    </TransitionChild>
                    <div class="flex flex-col h-full overflow-y-scroll bg-white shadow-xl">
                      <div class="relative flex-1">
                        <Suspense>
                          <!-- main content -->
                            <!-- Todo: Leverage suspense by fetching claim on query `claimId` update, loading + error -->
                            <div v-if="useClaimStore().claim && !useContextStore().isOrphanConversation">
                              <TopMenu />
                              <ClaimSteps />
                              <!-- <router-view class="child"></router-view> -->
                              <component :is="Component"></component>
                            </div>
                            <div v-else>
                              <FallbackClaimNotFound v-if="!useContextStore().isPlatformBrowser" />
                            </div>

                          <!-- loading state -->
                          <template #fallback>
                            Loading...
                          </template>
                        </Suspense>
                      </div>
                    </div>
                  </div>
                </TransitionChild>
              </div>
            </div>
          </div>
    </template>
  </RouterView>
  </TransitionRoot>
</template>